import React from 'react';
import PropTypes from 'prop-types';

import Fade from '@material-ui/core/Fade';

function ShowEffect({ children, show, onEntered = () => {}, onExited = () => {} }) {
    return (
        <Fade in={show} onEntered={onEntered} onExited={onExited}>
            {children}
        </Fade>
    );
}

ShowEffect.propTypes = {
    children: PropTypes.node,
    show: PropTypes.bool
};

export default ShowEffect;
